<template>
    <div class="app-container">
      <div class="flex">
        <div class="flex-left">
          <div class="tree-box">
            <BjDivider right-fixed>{{$t('AccountManagement.dept.Management')}}
              <template #right>
                <!-- <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('addText') }}</el-button> -->
              </template>
            </BjDivider>
            <el-tree :data="treeData" node-key="id" :highlight-current="true" :expand-on-click-node="false" :default-expanded-keys="['10']" @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <span>
                  <el-button icon="el-icon-plus" type="text" size="mini" @click="append(data)"></el-button>
                  <el-button :disabled="data.label == 'CSG' || data.children.length>0" icon="el-icon-minus" type="text" size="mini" @click="remove(node, data)"></el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="flex-right">
          <!-- :before-reset-search="reFreshLeftTree"  :before-query-search="beforeQuerySearch" -->
          <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :col-span="colSpan" :serial="serial" :search-btn-hide="true" @afterFetchOriginalData="afterFetchOriginalData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
            <template v-slot:tableColumn>
              <template v-for="(col, index) in dropCols">
                <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :min-width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                  <template slot-scope="scope">
                    <template v-if="false" />
                    <span v-else-if="col.prop === 'supervisor'">
                      <span>{{ scope.row.supervisorJSTrans }}</span>
                    </span>
                    <span v-else>{{ scope.row[col.prop] | timezoneFilters(scope.row[col.prop]) }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :min-width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" class="edit-btn" @click="onEdit(scope.row)">{{ $t('editText') }}</el-button>
                    <el-button type="text" class="delete-btn" @click="onDel(scope.row)">{{ $t('delText') }}</el-button>
                  </template>
                </el-table-column>
              </template>
            </template>
          </BjPage>
        </div>
      </div>
      <!-- 新增编辑弹窗 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="450px" :before-close="handleClose">
        <el-form ref="form" :model="form" label-position="top" :rules="rules">
          <el-col>
            <el-form-item :label="$t('AccountManagement.dept.department')" prop="name">
              <BjInput v-model="form.name" :placeholder="$t('AccountManagement.dept.department')"/>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item :label="$t('AccountManagement.dept.supervisor')" prop="supervisorName">
              <BjSelectLov v-model="form.supervisorName" multiple :option-list="supervisorList" :placeholder="$t('AccountManagement.dept.supervisor')"/>
            </el-form-item>
          </el-col>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="onSave()">{{ $t('okText') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  <script>
  let id = 1000;
  import pageMiXin from '@/utils/page-mixin.js';
  import { funConfigApi } from '@/api';
  import { getLanguage } from '@/lang/index';
  const getDefaultForm = () => {
    return {
      openType: null,
      id: null,
      name: null,
      supervisorName: [],
    };
  };
  
  export default {
    name: 'BusinessUserDeptManagement',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        queryApi: funConfigApi.getWarehouseDeptList,
        queryParams: {
          parentId: null,
        },
        labelList: [
          { label: this.$t('AccountManagement.dept.department'), prop: 'name', isCheck: true, disabled: false, width: getLanguage() === 'en' ? 80 : 80 },
          { label: this.$t('AccountManagement.dept.supervisor'), prop: 'supervisor', isCheck: true, disabled: false, width: getLanguage() === 'en' ? 80 : 80 },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: getLanguage() === 'en' ? 130 : 110 },
        ],
        // 树形控件 mock数据
        treeData:[],
        // 弹窗相关数据
        dialogTitle:null,
        dialogFormVisible: false,
        form: getDefaultForm(),
        supervisorList:[],
        rules: {
          name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
          supervisorName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        },
      };
    },
    computed: {},
    mounted(){
      // 获取树形控件数据
      this.getTreeData('init')
      // 获取主管下拉框
      this.getDeptUserList()
    },
    methods: {
      // 列表接口触发后 获取两个金额显示：库存货物金额，未支付金额
      afterFetchOriginalData(res) {
        const arr = res.content && res.content.map(resp => {
          return {
            ...resp,
            supervisorJSTrans : this.supervisorList.filter(item => resp.supervisor.includes(item.value)).map(item => item.label).join(',')
          }
        });
        this.$nextTick(() => {
          this.$refs.BjPage.tableData = arr;
        });
      },
      // 获取树形控件数据
      getTreeData(init){
        funConfigApi.getWarehouseDeptTree().then(res=>{
          if(res.length>0){
            this.treeData = res
            if(init){
              this.queryParams.parentId = this.treeData[0].id
            }
            this.reFresh()
          }else{
            this.treeData = []
          }
        })
      },
      // 获取主管下拉框
      getDeptUserList(){
        funConfigApi.getWarehouseDeptUserList().then(res=>{
          if(res.length>0){
            this.supervisorList = res.map(resp=>{
              return {label:resp.realName,value:resp.id}
            })
          }else{
            this.supervisorList = []
          }
        })
      },
      // 点击树形控件名称触发：刷新并重新获取右侧列表数据
      handleNodeClick(data) {
        this.queryParams.parentId = data.id
        this.reFresh();
      },
      // 新增
      onAdd(){
        this.dialogTitle = this.$t('addText')
        this.form.openType = 'add'
        this.dialogFormVisible = true;
      },
      // 树形控件(+)新增
      append(data) {
        this.dialogTitle = this.$t('addText')
        this.form.parentId = data.id
        this.form.openType = 'append'
        this.dialogFormVisible = true;
      },
      // 列表编辑
      onEdit(row) {
        this.dialogTitle = this.$t('editText')
        this.form = JSON.parse(JSON.stringify(row));
        this.form.openType = 'edit'
        this.form.supervisorName = this.form.supervisor
        this.dialogFormVisible = true;
      },
      // 树形控件(-)移除
      remove(node, data) {
        // console.log(node,'node');
        // console.log(data,'data');
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            funConfigApi.delWarehouseDeptMenuList({id: data.id}).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                // 刷新树形控件数据
                this.getTreeData()
                // 刷新列表数据
                this.reFresh();
              }
            });
          })
          .catch(() => { });
      },
      // 列表删除
      onDel(row) {
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            funConfigApi.delWarehouseDeptMenuList({id: row.id}).then(res => {
              if(!res.failed){
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                // 刷新树形控件数据
                this.getTreeData()
                // 刷新列表数据
                this.reFresh();
              }
            });
          })
          .catch(() => { });
      },
      // 保存弹窗数据 并 关闭编辑弹窗
      onSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if(this.form.openType == 'add'){
              const POST_DATA = {
                name : this.form.name,
                supervisor : this.form.supervisorName,
                parentId : 0
              }
              funConfigApi.addWarehouseDeptList(POST_DATA).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  // 清空弹框数据
                  this.handleClose()
                  // 刷新树形控件数据
                  this.getTreeData()
                  // 刷新列表数据
                  this.reFresh();
                }
              });
            }else if(this.form.openType == 'append'){
              const POST_DATA = {
                name : this.form.name,
                supervisor : this.form.supervisorName,
                parentId : this.form.parentId
              }
              funConfigApi.addWarehouseDeptList(POST_DATA).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  // 清空弹框数据
                  this.handleClose()
                  // 刷新树形控件数据
                  this.getTreeData()
                  // 刷新列表数据
                  this.reFresh();
                }
              });
            }else if(this.form.openType == 'edit'){
              const POST_DATA = {
                name : this.form.name,
                supervisor : this.form.supervisorName,
                id : this.form.id
              }
              funConfigApi.editWarehouseDeptList(POST_DATA).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  // 清空弹框数据
                  this.handleClose()
                  // 刷新树形控件数据
                  this.getTreeData()
                  // 刷新列表数据
                  this.reFresh();
                }
              });
            }
          }
        })
      },
      /** 关闭弹窗 清空数据 */
      handleClose() {
        this.form = getDefaultForm();
        this.$refs.form.resetFields();
        this.dialogFormVisible = false;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .flex {
    flex-wrap: nowrap;
    .flex-left {
      width: 333px;
      height: 100%;
      overflow: auto;
    }
    .flex-right {
      width: calc(100% - 333px);
    }
  }
  .tree-box {
    overflow: auto;
    min-height: 100%;
    height: calc(100vh - 265px);
    margin-right: 30px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
  